import Vue from 'vue'
import Editor from './editor.vue'

if ( document.getElementById( 'etm-editor-container' ) ) {

    window.tpEditorApp = new Vue({
        components: {
            'etm-editor' : Editor,
        },
        el: '#etm-editor-container',
        data: {
        },
    })

}
